import React from "react";
import { Badge, Box, IconButton, Stack } from "@mui/material";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  PickersCalendarHeaderProps,
  PickersDay,
  PickersDayProps,
} from "@mui/x-date-pickers-pro";
import moment from "moment";
import { NutritionDatesType } from "./calendar.types";
import { useTranslation } from "react-i18next";
import { formatter } from "app/utils";
import { Button } from "ui/Button";

function CalendarHeader(props: PickersCalendarHeaderProps) {
  const { currentMonth, onMonthChange } = props;

  const selectNextMonth = () => onMonthChange(moment(currentMonth).add(1, "M"));

  const selectPreviousMonth = () =>
    onMonthChange(moment(currentMonth).subtract(1, "M"));

  return (
    <div className="calendar-mui__header">
      <Stack spacing={1} direction="row">
        <IconButton onClick={selectPreviousMonth} title="Previous month">
          <ArrowLeftIcon />
        </IconButton>
      </Stack>
      <p>{currentMonth.format("MMMM YYYY")}</p>
      <Stack spacing={1} direction="row">
        <IconButton onClick={selectNextMonth} title="Next month">
          <ArrowRightIcon />
        </IconButton>
      </Stack>
    </div>
  );
}

const todayLabels = {
  ru: "Сегодня",
  en: "Today",
};

const TodayLabel = () => {
  const { i18n } = useTranslation();
  return (
    <p className="today-label">
      {todayLabels[i18n.language as "en" | "ru"]}:{" "}
      {formatter("D MMMM", i18n.language, new Date(), undefined, {
        withMonth: false,
        withYear: true,
      })}
    </p>
  );
};

const actionLabels = [
	{
		ru: "Выбрать",
		en: "Select",
	},
	{
		ru: "Сбросить всё",
		en: "Clear all",
	},
]

const ActionButtons = ({onSubmit, onReset, disableSubmit}: {onSubmit: (args?: any) => void, onReset: () => void, disableSubmit?: boolean}) => {
  const { i18n } = useTranslation();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem", margin: "0.875rem 0", width: "250px" }}>
      <Button buttonText={actionLabels[0][i18n.language as "en" | "ru"]} buttonColor="default" onClick={onSubmit} />
	  <Button buttonText={actionLabels[1][i18n.language as "en" | "ru"]} buttonColor="blank" onClick={onReset} />
    </Box>
  );
};

const NutritionDay = ({
  nutritionDates,
  ...props
}: PickersDayProps & { nutritionDates?: NutritionDatesType[] }) => {
  const date = nutritionDates?.find((e) => moment(e.date).isSame(props.day));
  return (
    <Badge
      key={props.day.format("YYYY-MM-DD")}
      overlap="circular"
      badgeContent={
        date ? <div className="calendar-badge">x{date.count}</div> : undefined
      }
    >
      <PickersDay
        {...props}
        day={props.day}
        outsideCurrentMonth={true}
        selected={false}
      />
    </Badge>
  );
};

export { CalendarHeader, NutritionDay, TodayLabel, ActionButtons };
